import React from 'react'
import Modal from 'react-bootstrap/Modal'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Alert from 'react-bootstrap/Alert'

import Backend from "../../../utils/Backend"
import AuthManager from "../../../utils/AuthManager"
import Event from "../../../utils/Event";
import AsyncSelect from "../common/AsyncSelect";
import Notify from "../../../utils/Notify";
import General from "../../../utils/General";

const getLinkieLabel = (linkie = {}) => (
  linkie.linkie_type === 'ai_query' ? 'AI Query' : 'Website'
)

export default class Linkie extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      loading: false,
      error: null,
      lists: [],
      ...this._getState(props),
    }
  }

  componentDidMount() {
    Backend.getLists().then(lists => {
      this.setState({lists})
    }).catch(e => General.showNotification(e.message, false))
  }

  componentWillReceiveProps(nextProps){
    this.setState(this._getState(nextProps))
  }

  _getState(props){
    return {
      ...props,
      show: props.show,
      linkie: props.linkie ? { 
        ...props.linkie, 
        is_public: props.linkie.is_public || false,
        active: props.linkie.active != null ? props.linkie.active : true
      } : props.list.id ? { list_ids: [props.list.id], is_public: false, active: true } : props.list.readLater ? { read_later: true, is_public: false, active: true } : { list_ids: [], is_public: false, active: true }
    }
  }

  _handleChange(e) {
    let linkie = this.state.linkie
    linkie[e.target.name] = e.target.value
    this.setState({ linkie, error: null })
  }

  _isFormValid(){
    let {
      name,
      url,
      list_ids
    } = this.state.linkie

    let error = null
    if(name == null || name.length === 0){
      error = "Please enter a valid title"
    }else if(url == null || url.length === 0){
      error = "Please enter a valid url"
    }else if(!this.state.linkie.read_later && list_ids.length < 1){
      error = "Please select a Collection"
    }

    if(error){
      General.showNotification(error, false)
      return false
    }
    return true
  }

  _handleSave(){
    let {
      linkie
    } = this.state

    if(!this._isFormValid()){
      return
    }

    this.setState({ loading: true })

    if(linkie.id){
      this._updateLinkie(linkie)
    }else{
      this._addLinkie(linkie)
    }
  }

  _addLinkie(linkie){
    Backend.addLinkie(linkie).then(linkie => {
      this.setState({ loading: false })
      General.showNotification("Website Saved")
      this.props.onSaved(linkie)
    }).catch(error => {
      this.setState({ loading: false })
      General.showNotification(error.message, false)
    })
  }

  _updateLinkie(linkie){
    const message = `${getLinkieLabel(linkie)} Updated`
    Backend.updateLinkie(linkie).then(linkie => {
      this.setState({ loading: false })
      General.showNotification(message)
      this.props.onSaved(linkie)
    }).catch(error => {
      this.setState({ loading: false })
      General.showNotification(error.message, false)
    })
  }

  render() {
    let {
      show,
      loading,
      linkie,
      error,
      lists,
    } = this.state

    let title = linkie.id ? "Update Website" : "Add New Website"
    let buttonTitle = linkie.id ? "Update" : "Save"
    let footerClass = linkie.read_later ? '' : 'pt-15'

    return (
      <Modal
        show={show}
        className="add-new-linkie"
        onHide={() => this.props.onHide()}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body
          className='scroll-y mx-5 mx-xl-15 my-7'
        >

          { error &&
            <Alert variant={"danger"}>
              { error }
            </Alert>
          }

          <div className="d-flex flex-column mb-7 fv-row">
            <label className="d-flex align-items-center fs-6 fw-bold form-label mb-2">
              <span className="required">New Website Name</span>
                <OverlayTrigger
                    overlay={
                      <Tooltip >
                        Enter the name of New Website
                      </Tooltip>
                    }
                  >
                    <i className="fas fa-exclamation-circle ms-2 fs-7" aria-label="Enter the name of New Website"></i>
                </OverlayTrigger>
            </label>
            <input
              type="text"
              name="name"
              className="form-control form-control-solid"
              placeholder="Enter Name"
              value={ linkie.name }
              onChange={e => this._handleChange(e)}
            />
          </div>

          <div className="d-flex flex-column mb-7 fv-row">
            <label className="required fs-6 fw-bold form-label mb-2">Link URL</label>
            <input
              type="text"
              name="url"
              className="form-control form-control-solid"
              placeholder="Enter Link"
              value={ linkie.url }
              onChange={e => this._handleChange(e)}
            />
          </div>

          <div className="d-flex flex-column mb-7 fv-row">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <label className="fs-6 fw-bold form-label mb-0">Public</label>
                <div className="text-muted fs-7">Allows others to see and add this website</div>
              </div>
              <div className="form-check form-switch form-check-custom form-check-solid">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={linkie.is_public}
                  onChange={e => {
                    let linkie = this.state.linkie
                    linkie.is_public = e.target.checked
                    this.setState({ linkie })
                  }}
                />
              </div>
            </div>
          </div>

          <div className="d-flex flex-column mb-7 fv-row">
            <div className="d-flex align-items-center justify-content-between">
              <div>
                <label className="fs-6 fw-bold form-label mb-0">Active</label>
                <div className="text-muted fs-7">Enable or disable this website</div>
              </div>
              <div className="form-check form-switch form-check-custom form-check-solid">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={!!linkie.active}
                  onChange={e => {
                    let linkie = this.state.linkie
                    linkie.active = e.target.checked
                    this.setState({ linkie })
                  }}
                />
              </div>
            </div>
          </div>

          {
            !linkie.read_later &&
            <>
              <hr className="mb-7 dashed"/>

              <div className="d-flex flex-column mb-7 fv-row">
                <label className="fs-6 fw-bold form-label mb-2">
                  Collections<br/>
                  <small>Please choose which folders you want to add the Website to</small>
                </label>
                <div className="lists">
                  <div className="row">
                    <div className="col">
                      {
                        lists.map(list => (
                          <>
                            <input
                              type="checkbox"
                              className="btn-check"
                              id={`list-${list.id}`}
                              autoComplete="off"
                              checked={linkie.list_ids.includes(list.id)}
                              onChange={e => {
                                let index = linkie.list_ids.indexOf(list.id)
                                if(index !== -1){
                                  linkie.list_ids.splice(index, 1)
                                }else{
                                  linkie.list_ids.push(list.id)
                                }
                                this.setState({linkie})
                              }}
                            />
                            <label className="btn btn-light-primary btn-sm" htmlFor={`list-${list.id}`}>{list.name}</label>
                          </>
                        ))
                      }
                    </div>
                  </div>
                </div>
              </div>
            </>
          }

          <div className={`text-center ${footerClass}`}>
            <div className='buttons-grid gg-7'>
              <button
                type="button"
                className="btn btn-light"
                onClick={() => this.props.onHide()}
              >
                Discard
              </button>

              <button
                type="button"
                className="btn btn-primary"
                disabled={loading}
                onClick={() => this._handleSave()}
              >
                {buttonTitle}
              </button>
            </div>
          </div>

        </Modal.Body>

      </Modal>
    )
  }
}
